import { useEffect, useState } from 'react';
import { adminApiClient, type MeCapabilities } from './adminApiClient';

interface CapabilitiesState {
  data: MeCapabilities | null;
  loading: boolean;
  error: string | null;
}

/**
 * Fetches the caller's admin role + capability set from the server
 * (GET /admin/me/capabilities). The portal renders/hides UI from `has(cap)`,
 * but this is cosmetic — the admin-api re-checks every mutation server-side.
 */
export function useCapabilities(): CapabilitiesState & { has: (cap: string) => boolean } {
  const [state, setState] = useState<CapabilitiesState>({
    data: null,
    loading: true,
    error: null,
  });

  useEffect(() => {
    let alive = true;
    adminApiClient
      .getCapabilities()
      .then((data) => alive && setState({ data, loading: false, error: null }))
      .catch((err: Error) =>
        alive && setState({ data: null, loading: false, error: err.message }),
      );
    return () => {
      alive = false;
    };
  }, []);

  return {
    ...state,
    has: (cap: string) => state.data?.capabilities.includes(cap) ?? false,
  };
}
